import { useState, useEffect } from 'react';
import { nextDeadline, offerActive } from '../utils';

export const useCountdown = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const target = nextDeadline(now);
  const diff = Math.max(0, target - now);
  const active = offerActive(now) && diff > 0;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff / 1000 / 60) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return { active, hours, minutes, seconds };
};

export const pad2 = (n) => String(n).padStart(2, '0');
export const clockText = ({ hours, minutes, seconds }) => `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;

export const formatCountdown = ({ hours, minutes, seconds }) => {
  const m = String(minutes).padStart(2, '0');
  const s = String(seconds).padStart(2, '0');
  if (hours > 0) return `${hours}h ${m}m ${s}s left`;
  return `${m}m ${s}s left`;
};
